const defaultConfig = {};
export default function normalizeArgs(method) {
    function normalized(func, config = defaultConfig, funcArgs = []) {
        if (Array.isArray(config)) {
            funcArgs = config;
            config = defaultConfig;
        }
        return method(func, config, funcArgs);
    }
    return normalized;
}
//# sourceMappingURL=normalizeArgs.js.map